export const SCOPE = 'networkRequest';
export const SET_DRILL_DOWN_STATE = `${SCOPE}/SET_DRILL_DOWN_STATE`;
export const SET_SYNCED_AUTO_REFRESH_STATE = `${SCOPE}/SET_SYNCED_AUTO_REFRESH_STATE`;
